import type { ReactNode } from 'react'
import type { StepId } from '../../model/delivery'
import { V1Header } from '../kit'
import type { V1IconName } from '../sprite'
import { useHeaderFarmer, useV1, V1_STEP_NO } from './ctx'

/** Header of a delivery step screen (farmer, pending, मदद, title; the step dots on paper). */
export function StepHeader({
  icon,
  title,
  step,
  onBack,
  onMore,
}: {
  icon: V1IconName
  title: string
  step: StepId
  onBack: () => void
  onMore?: () => void
}): ReactNode {
  const { d, pending, exit } = useV1()
  const farmer = useHeaderFarmer()
  return (
    <V1Header
      onBack={onBack}
      onHome={exit}
      farmer={farmer}
      pending={pending}
      icon={icon}
      title={title}
      // Live days have no fixed order (the task list), so the step dots are for paper only.
      step={d.capture_mode === 'PAPER_BACKFILL' ? V1_STEP_NO[step] : undefined}
      onMore={onMore}
    />
  )
}
